import styled from 'styled-components';
import { Flex } from 'foundations-components/components/Flex';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { trackWizardInteraction } from '../../../utils/usageTracker';
import { CLICK_CREATE_GOAL, FINISH_ONBOARDING } from '../../../constants/Events';
import { createNewGoalsUrl } from '../../../utils/urls';
import UIButton from 'UIComponents/button/UIButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StyledP = styled.p.withConfig({
  displayName: "Finish__StyledP",
  componentId: "xi8rcq-0"
})(["max-width:450px;text-align:center;"]);
const Finish = () => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx(Flex, {
    justifyContent: "center",
    children: /*#__PURE__*/_jsx(Illustration, {
      name: "success",
      width: "15%"
    })
  }), /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h2",
      marginBlock: "800",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "wizard.finish.header"
      })
    }), /*#__PURE__*/_jsx(StyledP, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "wizard.finish.description"
      })
    }), /*#__PURE__*/_jsx(StyledP, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "wizard.finish.suggestionText"
      })
    }), /*#__PURE__*/_jsx(StyledP, {
      children: /*#__PURE__*/_jsx(UIButton, {
        use: "secondary",
        "data-test-id": "create-goal-button",
        href: createNewGoalsUrl(),
        external: true,
        onClick: () => trackWizardInteraction(FINISH_ONBOARDING, CLICK_CREATE_GOAL),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "wizard.finish.suggestionButton"
        })
      })
    })]
  })]
});
export default Finish;